import { Platform } from "@xt/xtbase";

/** App WebView：UA / JSBridge（与 user-center isInApp 对齐） */
export function isInAppWebView() {
  if (typeof window === "undefined") return false;
  if (Platform.isInApp && Platform.isInApp()) return true;
  const ua = (window.navigator?.userAgent || "").toLowerCase();
  if (ua.includes("com.xt.app")) return true;
  if (window.webkit?.messageHandlers?.xt_h5) return true;
  if (typeof window.android?.xt_h5 === "function") return true;
  return false;
}

/**
 * PRD client_type：浏览器 h5；App 内嵌 WebView 按系统报 ios / android。
 * @returns {"h5"|"ios"|"android"}
 */
export function resolveBehaviorClientType() {
  if (typeof window === "undefined") return "h5";
  if (!isInAppWebView()) return "h5";
  if (Platform.isIOS && Platform.isIOS()) return "ios";
  if (Platform.isAndroid && Platform.isAndroid()) return "android";
  return "h5";
}
